import { CartErrorDialog } from './error/CartErrorDialog';
import { CartUserPromptDialog } from './user-prompt/CartUserPromptDialog';
import { CartBusyDialog } from './busy/CartBusyDialog';
import { useCartErrorNotification } from '../state-hooks/useCartErrorNotification';
import { useCartUserPromptNotification } from '../state-hooks/useCartUserPromptNotification';
import { useCartIsBusy } from '../state-hooks/useCartIsBusy';

export function CartDialog() {
  const { errorDialogContentDescriptor } = useCartErrorNotification();
  const { userPromptDialogContentDescriptor } = useCartUserPromptNotification();
  const { busyDialogContentDescriptor } = useCartIsBusy();

  if (errorDialogContentDescriptor) {
    return <CartErrorDialog errorDialogContentDescriptor={errorDialogContentDescriptor} />;
  } else if (userPromptDialogContentDescriptor) {
    return <CartUserPromptDialog userPromptDialogContentDescriptor={userPromptDialogContentDescriptor} />;
  } else if (busyDialogContentDescriptor) {
    return <CartBusyDialog busyDialogContentDescriptor={busyDialogContentDescriptor} />;
  }

  return null;
}
